<app-auth-view>
  <ng-container slot="title">Wachtwoord wijzigen</ng-container>
  <ng-container slot="message">Vul hieronder je nieuwe wachtwoord in</ng-container>

  <ng-container slot="content">
    <app-reset-password-form class="block mt-10" />

    <a
      routerLink="/login"
      class="self-center font-medium text-sm mt-3 hover:underline"
      >Terug naar inloggen</a
    >
  </ng-container>
</app-auth-view>
